import React from 'react';
import { createRoot } from 'react-dom/client';
import domReady from '@wordpress/dom-ready';
import { NeighbourhoodMap } from './NeighbourhoodMap';

domReady(() =>
	{
	// render.php emits the mount point only when it has coordinates, a key and a
	// map ID, so anything found here is known to be renderable.
	const mounts = document.querySelectorAll<HTMLElement>('.property-neighbourhood__map[data-lat]');

	mounts.forEach((mount) =>
		{
		const { lat, lng, apiKey, mapId, title, zoom } = mount.dataset;

		if (!lat || !lng || !apiKey || !mapId) return;

		createRoot(mount).render(
			<NeighbourhoodMap
				lat={parseFloat(lat)}
				lng={parseFloat(lng)}
				title={title ?? ''}
				apiKey={apiKey}
				mapId={mapId}
				zoom={zoom ? parseInt(zoom, 10) : 15}
				/>
			);
		});
	});
